import Vue from 'vue';
import request from '@/utils/request';
import commonFilter from '@/filters/common-filter';
import TokenShared from '@/token-shared'; // permission control
import utils from './utils';
import clientConfig from './config';
import globalMixin from './mixins/global';

// 重写message
const overrideMessage = () => {
  utils.overrideMessage();
};

// baseURL初始化
const initBaseUrlConfig = () => {
  if (process.env.NODE_ENV === 'development') {
    Vue.prototype.$baseURL = serverConfig.nodeUrl;
  }
  if (process.env.NODE_ENV === 'production') {
    // Vue.prototype.$baseURL =
    //   window.location.href.split('//')[0] +
    //   '//' +
    //   window.location.href.split('//')[1].split('/')[0];
    Vue.prototype.$baseURL = 'https://mall.linkiebuy.com'
    request.defaults.baseURL = 'https://mall.linkiebuy.com';
    
  }
  
  console.log('baseurl',Vue.prototype.$baseURL)
};

// 初始化event
const initOnEvent = () => {
  Vue.prototype.$onEvent = new Vue();
};

// 上传与显示图片相关配置
const initImgAndUploadConfig = () => {
  request.defaults.imgBasicUrl = serverConfig.imgBasicUrl;
  Vue.prototype.$http = request;
  Vue.prototype.$imgBasicUrl = serverConfig.imgBasicUrl;
  Vue.prototype.uploadUrl = clientConfig.uploadUrl;
  Vue.prototype.$lodash = _;
};

// 全局引入过滤器
const initGlaobalFilter = () => {
  Object.keys(commonFilter).forEach(key => {
    Vue.filter(key, commonFilter[key]);
  });
};

// productionTip 初始化
const initpProductionTip = () => {
  Vue.config.productionTip = false;
};

// token share 初始化
const initTokenShare = () => {
  TokenShared.init();
};

// 注入全局mixin
const initGloabalMixin = () => {
  Vue.mixin(globalMixin);
};

const initVueConfig = () => {
  overrideMessage();
  initBaseUrlConfig();
  initOnEvent();
  initImgAndUploadConfig();
  initGlaobalFilter();
  initTokenShare();
  initpProductionTip();
  initGloabalMixin();
};

export { initVueConfig };
